/*
 * Lib Module Infotips
 */

Lib.Infotip = (function() {

    // Options
    const self = {
        currentTooltip: null,
        infoTipUrl: '/infotips/get.json',
        editor: null
    };

    // Document ready
    $(Lib).on('document.ready', function() {

        // If we want infotips for the current page
        if (Lib.Hash.get(Lib, 'options.infotips', false) !== false) {
            self.bindInfotips();

            // If there is a script template for the editor
            if ($('script[data-template=\'infotip-editor\']').length) {
                $(document).on('click', '[data-infotips-edit]', function(e) {
                    e.preventDefault();
                    self.toggleEdit();
                });

            }
        }
    });

    /**
     * bind the infotips
     * @param infotips
     * @param cb
     */
    self.bindInfotips = function(infotips, cb) {

        infotips = infotips || $('div[data-infotip], span[data-infotip]').not('[data-no-infotips] div[data-infotip], [data-no-infotips] span[data-infotip], [data-static-tip]');
        cb = cb || Lib.Noop.true;

        infotips.html('');

        let tipids = [];

        // Gather all infotips
        infotips.each(function() {
            let tipid = $(this).data('infotip');
            let tiptype = $(this).data('infotipType');
            if (tipid !== '') {
                tipids.push(tiptype + ':' + tipid);
            }
        });

        // If we found any
        if (tipids.length) {

            // Get the infotips from the backend
            $.ajax({
                url: self.infoTipUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'infotips[]': tipids,
                    corporation_id: Lib.Hash.get(Lib, 'options.data.corporation_id', false)
                },
                success: function(data) {
                    // If our response is properly formatted
                    if (typeof data === 'object' && 'response' in data) {

                        // Loop through the infotip result and make the tips, just the tips...
                        $.each(data.response, function(id, ops) {

                            let infoTip = Lib.Element.spawn('span', {'class': `infotip infotip-${ops.type}`, 'data-tooltip': Lib.String.decodeEntities(ops.content)}, '');

                            let infotipHolder = $('div[data-infotip=\'' + ops.id + '\'][data-infotip-type=\'' + ops.type + '\']');
                            if (infotipHolder.length === 0) {
                                infotipHolder = $('span[data-infotip=\'' + ops.id + '\'][data-infotip-type=\'' + ops.type + '\']');
                            }
                            infotipHolder.append(infoTip);
                        });

                        // Now bind the actual info tip,
                        Lib.Tooltip.bindTooltips($('div[data-infotip] i, span[data-infotip] i'));
                        cb();
                    }
                }
            });

        }
    };

    /**
     * Function to edit
     */
    self.toggleEdit = function() {
        if ($('script[data-template=\'infotip-editor\']').length) {
            let editor = null;
            let currentTooltips = $('div[data-infotip], span[data-infotip]').filter(function() {
                return ($(this).data('infotipType') === 'info');
            });

            if (currentTooltips.length === 0) {
                Lib.Modal.popup({title: 'Oeps!', content: 'Er zijn op deze pagina geen i\'tjes te bewerken!'});
                return;
            }
            currentTooltips.each(function() {
                if ($(this).find('span').length === 0) {
                    $(this).append(Lib.Element.spawn('span', {'class': 'infotip infotip-new'}, ''));
                } else {
                    $(this).find('span').removeClass('infotip-info').addClass('infotip-edit');
                }
            });

            $(document).on('click', 'div[data-infotip][data-infotip-type="info"], span[data-infotip][data-infotip-type="info"]', function() {
                let tip = $(this);
                let tipIcon = tip.find('span');

                let add_edit = 'bewerken';
                if (tipIcon.hasClass('infotip-new')) {
                    add_edit = 'toevoegen';
                }

                let label = $('label[for=\'' + $(this).data('infotip') + '\']');

                //
                if (label.length === 0) {
                    label = $('label[for=\'' + $(this).data('infotip') + 'Decimal\']');
                }

                //
                if (label.length === 0) {
                    label = $('label[for=\'' + $(this).data('infotip') + 'Picker\']');
                }
                //
                let title = (label.length) ? label.text() : '';
                self.currentTooltip = $(this);

                let tipContent = tipIcon.data('tooltip');

                Lib.Modal.createFromTemplate(
                    'infotip-editor',
                    {
                        title: title,
                        content: tipContent,
                        add_edit: add_edit
                    },
                    {
                        closable: false,
                        closebutton: false,
                        onClose: function() {
                            Lib.Util.reload(true);
                        },
                        onOpen: function() {

                            if (add_edit === 'toevoegen') {
                                $('.modal .modal-content [data-delete-tooltip]').remove();
                            }

                            let elEditor = $('#tip-content');

                            elEditor.html(tipContent);

                            self.editor = Lib.Wysiwyg.editor(elEditor.get(0));
                        }
                    }
                );

            });

            $(document).on('click', '[data-save-tooltip]', function() {
                let loaderHolder = $('.modal .modal-content .card');
                Lib.Loader.show(loaderHolder);
                let tip = self.currentTooltip;
                let tipid = tip.attr('data-infotip');
                let tiptext = $('#tip-content').val();

                $.ajax({
                    url: Lib.Format.url({
                        controller: 'infotips',
                        action: 'save.json'
                    }),
                    method: 'post',
                    data: {
                        data: {
                            tipid: tipid,
                            tiptext: tiptext
                        }
                    },
                    success: function() {
                        Lib.Modal.close();
                    },
                    error: function() {
                        Lib.Debug.warn('Something went wrong, server-side, saving the tip!');
                    }
                });
            });

            $(document).on('click', '[data-delete-tooltip]', function() {
                Lib.Modal.confirm(
                    {
                        color: 'red',
                        title: 'Ho even!',
                        subtitle: 'Dit kan niet ongedaan gemaakt worden',
                        content: 'Weet je zeker dat je deze infotip wilt verwijderen?',
                        buttons: {
                            // Yes button
                            'Ja': {
                                color: 'red',
                                onClick: function() {
                                    let loaderHolder = $('.modal .modal-content .card');
                                    Lib.Loader.show(loaderHolder);
                                    let tip = self.currentTooltip;
                                    let tipid = tip.attr('data-infotip');

                                    $.ajax({
                                        url: Lib.Format.url({
                                            controller: 'infotips',
                                            action: 'delete.json'
                                        }),
                                        method: 'post',
                                        data: {
                                            data: {
                                                tipid: tipid
                                            }
                                        },
                                        success: function() {
                                            Lib.Modal.close();
                                        },
                                        error: function() {
                                            Lib.Debug.warn('Something went wrong when deleting the tip! (server-side)');
                                            Lib.Modal.close();
                                        }
                                    });
                                }
                            },
                            // No button
                            'Nee': {
                                color: 'blue',
                                onClick: function() {
                                    self.currentTooltip.trigger('click');
                                }
                            }
                        }
                    },
                    {

                        onClose: function() {
                            Lib.Util.reload(true);
                        }
                    }
                );

            });
        }

    };

    return self;

})();
